import createPersistedState from "./createPersistedState";
import useEnv from "./useEnv";

type PersistedState = {
  has_completed_get_started_flow: boolean;
};

const DEFAULT_STATE: PersistedState = {
  has_completed_get_started_flow: false,
};

const usePersistedState = createPersistedState<
  Partial<{
    [env: string]: Partial<PersistedState>;
  }>
>("persisted_environment_state");

function usePersistedEnvironmentState<T extends keyof PersistedState>(
  key: T
): [PersistedState[T], (state: PersistedState[T]) => void] {
  const { selectedEnv } = useEnv();
  const [states, setStates] = usePersistedState({});

  const pub_id = selectedEnv?.pub_id ?? "(no env)";
  const envState = states[pub_id] ?? {};
  const setter = (state: PersistedState[T]) =>
    setStates({
      ...states,
      [pub_id]: { ...envState, [key]: state },
    });
  const value = envState[key] ?? DEFAULT_STATE[key];
  return [value, setter];
}

export default usePersistedEnvironmentState;
